import station from './station';

export default {
	stationPage: station
}
